const MODEL_NAME = 'sweety'

export default [
  {
    path: `/${MODEL_NAME}/question-answer`,
    name: 'questionAnswer',
    component: () => import(/* webpackChunkName: "question-answer" */ '@pages/question/index.vue')
  }
]
